// extracted by mini-css-extract-plugin
module.exports = {"dashboardMenu":"menu_dashboardMenu__OxySA","active":"menu_active__iAxAR","rightLanguage":"menu_rightLanguage__F_yHz","languageLocale":"menu_languageLocale__p682d"};